module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("60SPd"))).then(() => parcelRequire('8Axq6'));